module.exports = __webpack_public_path__ + "img/logo.a89e265a.png";